module.exports = __webpack_public_path__ + "media/src/images/printer_on-7e7536e63248897d3420a67f6ec3cb08.png";